import { render, staticRenderFns } from "./DashboardAlertList.vue?vue&type=template&id=6735af05&"
import script from "./DashboardAlertList.vue?vue&type=script&lang=js&"
export * from "./DashboardAlertList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports